module.exports = __webpack_public_path__ + "static/inseec-506255b2f86aae7a45b85feedf3dcaf6.png";